import axios from 'axios';
import { useAsync } from 'react-use';

import { ApiEndpoints } from '@utils/endpoints';
import { doesNotExist } from '@utils/general';

import { useAuth } from '@providers/AuthProvider';

import { IPricingResponse } from '@folx-types/pricing';

const useMembershipPricing = (billingFrequency: 'MONTHLY' | 'ANNUAL') => {
	const { email: memberEmail, getAuthToken } = useAuth();

	const requestParams = {
		billingFrequency,
		memberEmail,
	};

	const state = useAsync(async () => {
		if (doesNotExist(memberEmail)) {
			return;
		}

		const response = await axios.post<IPricingResponse>(ApiEndpoints.pricing, requestParams, {
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				authorizationToken: await getAuthToken(),
			},
		});

		return response.data;
	}, [billingFrequency, memberEmail]);

	return state;
};

export default useMembershipPricing;
